import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { ReactComponent as Loading } from "../../assets/icons/loader/Double-Ring.svg"
import { ReactComponent as Done } from "../../assets/icons/generals/done.svg"
import { ReactComponent as Cancel } from "../../assets/icons/generals/close.svg"
import { useRequestProcessor } from "../../api/requestProcessor";
import { checkIsAdmin } from "../../api/admin";
import { useEffect } from "react";
import { toast } from "react-toastify";


const  Login = () => {

    const [searchParams] = useSearchParams();
    const token = searchParams.get("_token");
    const navigate = useNavigate();

    const { Mutate } = useRequestProcessor()


    const auth = JSON.parse(localStorage.getItem("za_token"))



    const { mutate, isLoading, isSuccess, isError } = Mutate(
        ['checkIsAdmin', token],
        checkIsAdmin,
        {
            onSuccess: (data) => {
                if(data?.status == "success" ){
                    localStorage.setItem("za_token", JSON.stringify({
                        token: data?.token,
                        user_name: data?.user_name
                    }))
                    navigate("/admin/dashboard")
                    window.location.reload()
                }
                // setTimeout(() => window.location.reload(),3000)
            },
            onError : (data) => {
                toast.error(data.message)
            }
        }
    );

    useEffect(()=>{
        if(token){
            mutate({ "checkAdminCode": token })
        }
        else if(!token && auth?.token){
            mutate({ "checkAdminCode": auth?.token })
        }
        else{
            navigate("/admin/dashboard")
        }
        // if(!token && auth?.token ) {}
        // else{
        //     mutate({ "checkAdminCode": token })
        // }
    },[])

    return (
        <div className='flex justify-center items-center h-screen'>
            <div className="flex flex-col items-center">
                {
                    isLoading &&
                    <>
                        <h1 className="font-semibold">
                            در حال تایید حساب شما هستیم.کمی صبر کنید ...
                        </h1>
                        <Loading className="w-[200px] h-[200px] !m-0 mt-10" />
                    </>
                }
                {
                    isSuccess &&
                    <>
                        <h1 className="font-semibold">
                            حساب با موفقیت تایید شد. در حال ورود به پنل ...
                        </h1>
                        <Done className="w-[200px] h-[200px] !m-0 mt-10" />
                    </>
                }
                {
                    isError &&
                    <>
                        <h1 className="font-semibold">
                            شما اجازه دسترسی به پنل ندارید .<br />
                            در صورت مشکل به مدیر اطلاع دهید
                        </h1>
                        <Cancel className="w-[200px] h-[200px] !m-0 mt-10" />
                    </>
                }


            </div>
        </div>
    )
}

export default Login